import * as React from 'react'
import { safeBoolean } from '../../utils/utils';
import { Badge, badges } from '@dvui'

export interface IXRayBadgeProps {
  isXRay?: boolean
}

export const XRay = ({ isXRay }: IXRayBadgeProps) => (
  safeBoolean(isXRay) && (
    <Badge use={badges.X_RAY}>
      <span data-automation-id="x-ray-badge">X-Ray</span>
    </Badge>) || null
)
